export default __webpack_public_path__ + "static/media/banner-fidelidade.cb850bed.png";